import { useEffect } from "react";
import { useWorkShiftStore } from "../../../../hooks";
import { LoadingData, ErrorMessage, SuccessMessage } from "../../../ui";
import { translationShiftTypes } from "../../../data";

export const WorkShiftTable = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    workShifts,
    message,
    params,
    pageSize,
    page,

    // Methods
    startGetWorkShifts,
  } = useWorkShiftStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (workShifts.data.length === 0) {
      startGetWorkShifts(params, page, pageSize);
    }
  }, [workShifts.data, startGetWorkShifts, params, page, pageSize]);

  return (
    <>
      {workShifts.isLoading && <LoadingData className="mb-4" />}
      {workShifts.message?.type === "error" && (
        <ErrorMessage className="mb-4">{workShifts.message.text}</ErrorMessage>
      )}
      {message?.type === "success" && (
        <SuccessMessage className={"mb-4"}>{message.text}</SuccessMessage>
      )}

      <div
        className="table-responsive shadow rounded"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        <table className="table table-center bg-white mb-0">
          <thead>
            <tr>
              <th className="border-bottom p-3" style={{ minWidth: "50px" }}>
                #
              </th>
              <th className="border-bottom p-3">Doctor</th>
              <th className="border-bottom p-3">Jornada</th>
              <th className="border-bottom p-3">Fecha</th>
            </tr>
          </thead>
          <tbody>
            {workShifts.data.map((workShift, index) => (
              <tr key={workShift.id}>
                <th className="p-3">{index + 1}</th>
                <td className="py-3">{`${workShift.doctor.user.firstName} ${workShift.doctor.user.lastName}`}</td>
                <td className="py-3">
                  {translationShiftTypes[workShift.shiftType]}
                </td>
                <td className="py-3">{workShift.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
